import React from "react";

const EmptyState = ({
  title = "No data found",
  message = "There is nothing to display here.",
  action = null,
  icon = "○",
  className = ""
}) => {
  return (
    <div className={`ui-empty-state ${className}`}>
      <div className="ui-empty-icon">
        {icon}
      </div>

      <h3 className="ui-empty-title">
        {title}
      </h3>

      <p className="ui-empty-message">
        {message}
      </p>

      {action && (
        <div className="ui-empty-action">
          {action}
        </div>
      )}
    </div>
  );
};

export default EmptyState;